<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="list">全部投放记录</el-menu-item>
          <el-menu-item index="add" v-if="permissions.delivery_edit">创建投放记录</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
        <delivery-list v-if="activeIndex == 'list'"></delivery-list>
        <delivery-add v-if="activeIndex == 'add'" @toDeliveryList="dealToDeliveryList"></delivery-add>
      </div>
    </div>
  </div>
</template>

<script>
import deliveryList from "./component/list";
import deliveryAdd from "./add";
import { mapGetters } from "vuex";

export default {
    computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  data() {
    return {
      activeIndex: "list",
      queryData: {}
    };
  },
  components: {
    deliveryList,
    deliveryAdd
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
    dealToDeliveryList() {
      this.activeIndex = 'list';
    }
  }
}
</script>